import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { defaultLocale } from './config';

export const i18n = i18next.createInstance();

export const i18nReady = i18n.use(initReactI18next).init({
	defaultNS: 'common',
	fallbackLng: defaultLocale,
	interpolation: {
		escapeValue: false
	},
	lng: defaultLocale,
	resources: {},
	returnNull: false,
	react: {
		useSuspense: false
	}
});
